import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import { Form } from 'semantic-ui-react'

import { Button } from 'components/Common'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

const AuthForm = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)

  const onSubmit = values => props.onSubmit(values)

  return <FinalForm
    validate={props.validate}
    onSubmit={onSubmit}
    render={({ handleSubmit }) =>
    <Form onSubmit={handleSubmit} style={styles.form}>
      <div style={styles.title}>{props.title}</div>
      <div>{props.children}</div>
      <Button type="submit" style={styles.button}>{props.submitLabel}</Button>
    </Form>}
  />
}
export default AuthForm
